<template>
  <div>
    <CRow>
      <CCol sm="12">
        <ZonesTable
          :items="zones"
          hover
          striped
          border
          small
          fixed
          caption="Zonas"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ZonesTable from '../../components/zones/ZonesTable.vue'
import ws from '../../services/zones';
import store from '../../store'

export default {
  name: 'Zones',
  components: { ZonesTable },
  data: function () {
		return {
            zones: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      this.zones = response.data;
    }

    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.zones = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
